module.exports = "<div mat-dialog-content style=\"text-align: center\">\r\n    <p>Your password is changed successfully</p>\r\n  </div>\r\n  "